<div class="widget__wrap">
  <div class="widget" id="social-widget">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Sociální sítě</span>
      <span class="widget__header__tools">
        <a class="cta cta--small cta--green" [routerLink]="['social/add']">
          <span class="cta__light">Přidat</span> sociální síť
          <i class="ico-plus"></i>
        </a>
      </span>
    </h2>
    <div class="widget__content">
      <swb-social-list></swb-social-list>
    </div>
  </div>
</div>